// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-banner-sec {
  position: fixed;
  top: 110px;
  left: 0;
  width: 100%;
  z-index: 999999999;
}
.campaign-banner-sec.position-bottom {
  top: auto;
  bottom: 0px;
}
.campaign-banner-sec.floating-banner {
  position: absolute;
}
.campaign-banner-sec .banner-data-info {
  border: 1px solid var(--kora-grey-grey-light-3, #E4E5E7);
  background: #4B4EDE;
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  padding: 16px 24px;
  display: flex;
  align-items: flex-start;
  gap: 24px;
  justify-content: center;
}
.campaign-banner-sec .banner-data-info .info-p-data {
  width: 100%;
  text-align: center;
  color: var(--base-white, #FFF);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.campaign-banner-sec .banner-data-info .info-p-data p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.campaign-banner-sec .banner-data-info .close_banner {
  flex-shrink: 0;
  line-height: 0;
  font-size: 16px;
  cursor: pointer;
  background: transparent;
  padding: 0;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/plugins/proactiveWebCampaign/templates/pwcBannerTemplate/pwcBannerTemplate.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;AACJ;AAAI;EACI,SAAA;EACA,WAAA;AAER;AAAI;EACI,kBAAA;AAER;AAAI;EACI,wDAAA;EACA,mBAAA;EACA,mDAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;AAER;AADQ;EACI,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAGZ;AAFY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAIhB;AADQ;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;AAGZ","sourcesContent":[".campaign-banner-sec{\n    position: fixed;\n    top: 110px;\n    left: 0;\n    width: 100%;\n    z-index: 999999999;\n    &.position-bottom{\n        top: auto;\n        bottom: 0px;\n    }\n    &.floating-banner{\n        position: absolute;\n    }\n    .banner-data-info{\n        border: 1px solid var(--kora-grey-grey-light-3, #E4E5E7);\n        background: #4B4EDE;\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        padding: 16px 24px;\n        display: flex;\n        align-items: flex-start;\n        gap: 24px;\n        justify-content: center;\n        .info-p-data{\n            width: 100%;\n            text-align: center;\n            color: var(--base-white, #FFF);\n            display: flex;\n            flex-direction: column;\n            gap: 6px;\n            p{\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 24px;\n            }\n        }\n        .close_banner{\n            flex-shrink: 0;\n            line-height: 0;\n            font-size: 16px;\n            cursor: pointer;\n            background: transparent;\n            padding: 0;\n            border: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
